import Vue from 'vue'
import Router from 'vue-router'
import MainMenu from '@/components/MainMenuView'
import JapanMenu from '@/components/JapanMenu.vue'
import JapanNormal from '@/components/JapanNormal.vue'
import JapanNormal2 from '@/components/JapanNormal2.vue'
import JapanHard from '@/components/JapanHard.vue'
import WorldMenu from '@/components/WorldMenu.vue'
import WorldNormal from '@/components/WorldNormal.vue'
import WorldHard from '@/components/WorldHard.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/world',
      component: WorldMenu
    },
    {
      path: '/world_normal',
      component: WorldNormal
    },
    {
      path: '/world_hard',
      component: WorldHard
    },
    {
      path: '/japan',
      component: JapanMenu
    },
    {
      path: '/japan_normal',
      component: JapanNormal
    },
    {
      path: '/japan_normal2',
      component: JapanNormal2
    },
    {
      path: '/japan_hard',
      component: JapanHard
    },
    {
      path: '/main_menu',
      component: MainMenu
    },
    {
      path: '*',
      redirect: '/main_menu'
    }
  ]
})

